export default "__VITE_ASSET__DpmGY9M2__"